<ng-container *ngIf="materialContainer && materialContainer.materials.length">
  <div style="display: inline-flex; flex-direction: column;">
    <div style="margin: auto; display: inline-flex; flex-direction: column;">
      <div *ngFor="let material of materialContainer.materials">
        {{materialToString(material)}}
        <button style="margin-left: 4px;" (click)="deleteTicketMaterial(material)">
          <fa-icon [icon]="faTrash"></fa-icon>
        </button>
      </div>
    </div>
  </div>
  <br>
</ng-container>
<ng-container *ngIf="!showAddMaterialDialog">
  <button style="border: 1px solid black;" class="bm-btn bm-btn-primary" (click)="addMaterial()">
    <fa-icon style="margin: auto; padding: 0 4px; font-size: .75rem;" [icon]="faPlus"></fa-icon> Material
  </button>
</ng-container>
<div *ngIf="showAddMaterialDialog" class="bg-base-200" style="color: black; min-width: 480px;">
  <form [formGroup]="newMaterialForm" (submit)="saveMaterial()">

    <fieldset class="bm-card-body">
      <div class="relative">
        <h4 class="bm-card-title">
          Hinzufügen:
        </h4>
        <div class="controles-container horizontal_flex absolute right-0" style="border: 1px solid black; top: -16px; border-radius: 6px;">
          <fa-icon [icon]="faFilter" style="margin: auto 0; width: 36px; text-align: center"></fa-icon>
          <select class="bm-select" [(ngModel)]="selectedTemplateFilter" [ngModelOptions]="{ standalone: true }" (change)="updateSelectedTemplateFilter($event.target)">
            <option [value]="'all'">Alle</option>
            <option [value]="'exclusive_project'">Nur Projekt-Material</option>
            <option [value]="'inclusive_project'">Projekt/Unspezifiziertes Material</option>
          </select>
        </div>
      </div>
      <div class="flex_row">
        <mat-form-field appearance="outline" class="outline-small flex-4 relative">
          <mat-select formControlName="article_template_id">
            <div class="flex_col h-full w-full">
              <input class="bm-input" style="margin: 0 4px 6px 4px; width: calc(100% - 8px)" type="search" (search)="filterArticleTemplates($event)" (keyup)="filterArticleTemplates($event)" placeholder="Suche Template...">
              <div style="flex: 1; overflow-y: auto;">
                <mat-option style="font-size: .8rem!important">None</mat-option>
                <ng-container *ngFor="let article_template of filteredArticleTemplates">
                  <mat-option style="font-size: .8rem!important" [value]="article_template.id">{{formatArticleTemplate(article_template)}}</mat-option>
                </ng-container>
              </div>
            </div>
          </mat-select>
        </mat-form-field>
        <input class="bm-input" style="width: 64px;" formControlName="amount" type="number" min="1" placeholder="Anzahl">
        <input class="bm-input flex-1" formControlName="serial_number" type="text" placeholder="Seriennummer">
      </div>
      <div class="flex_row">
        <button class="bm-btn bm-btn-error" type="button" style="margin-left: auto; margin-right: 6px;" (click)="showAddMaterialDialog = false">abbrechen</button>
        <button class="bm-btn bm btn-primary" type="submit" [disabled]="newMaterialForm.invalid">hinzufügen</button>
      </div>
    </fieldset>
  </form>
</div>
